import { GameLock } from '@/_models/Game';

export enum ELockInfo {
  err,
  ok,
  info_collect,
  info_sequence,
  reset_sequence,
}

export interface ILockInfoPopup {
  rtl: boolean;
  answerIndicatorOn: boolean;
  translation: Record<string, string>;
  manualData: null | TLockItem;
  setManualData: (data: null | TLockItem) => void;
  setShowNewHintModal: (show: null | number) => void;
}
export type TLockItem = {
  value: ELockInfo;
  text?: string;
  name?: string;
  time?: number;
  obj: GameLock;
};
export type TLockInfoPopup = { id: number; timeoutId: any; value: ELockInfo } & TLockItem;
